import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWallet, faArrowDown, faArrowUp } from '@fortawesome/free-solid-svg-icons';
import { useNavigate, useSearchParams } from 'react-router-dom';
import axios from 'axios';

const WalletPage = () => {
  const [balance, setBalance] = useState(0.0);
  const [paymentState, setPaymentState] = useState('');
  const [merchantOrderId, setMerchantOrderId] = useState('');
  const [message, setMessage] = useState('');
  const [paymentUrl, setPaymentUrl] = useState('');
  const [fundpage, setFundpage] = useState(false);
  const [amount, setAmount] = useState('');
  const [selectedAmount, setSelectedAmount] = useState('');
  const [searchParams] = useSearchParams();
  const OrderId = searchParams.get("orderId");
  const navigate = useNavigate();

  const transactions = [
    { id: 1, type: 'credit', amount: 500, description: 'Course Payment Received', date: '2025-07-10' },
    { id: 2, type: 'debit', amount: 250, description: 'Exam Fee Paid', date: '2025-07-08' },
    { id: 3, type: 'credit', amount: 1000, description: 'Referral Bonus', date: '2025-07-05' },
  ];

  useEffect(() => {
    fetchData();

    // Load payment status from localStorage if exists
    const savedStatus = localStorage.getItem("paymentStatus");
    if (savedStatus) {
      setPaymentState(savedStatus);
      localStorage.removeItem("paymentStatus");
    }
  }, []);

  const fetchData = async () => {
    const userId = localStorage.getItem('UserId');
    if (!userId) return;

    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API}/wallet/getwalletamount/${userId}`
      );
      setBalance(response.data.balance);
    } catch (error) {
      console.error("Failed to fetch wallet balance:", error);
    }
  };

const addammount = async (amountValue) => {
    const parsedAmount = parseFloat(amountValue);
    if (!parsedAmount || isNaN(parsedAmount) || parsedAmount <= 0) {
        alert('Please enter a valid positive amount');
        return;
    }

    try {
        const userId = localStorage.getItem('UserId');
        if (!userId) {
            alert('User not logged in.');
            return;
        }

        const response = await axios.put(
            `${process.env.REACT_APP_API}/wallet/addamount/${userId}`,
            { amount: parsedAmount }
        );

        alert(response.data.message || 'Amount added successfully');
        fetchData();
    } catch (error) {
        console.error('Failed to add amount:', error);
        alert(error.response?.data?.error || 'Failed to add amount. Please try again.');
    }
};


  

  const getAuthToken = async () => {
    try {
      const response = await axios.post(`https://ramjitrust.org:4000/payment/get-auth-token`);
      return response.data.access_token;
    } catch (error) {
      console.error("Error fetching auth token:", error);
      setMessage("Failed to initialize payment system");
      return null;
    }
  };

  const generateOrderId = () => {
    const timestamp = Date.now();
    const random = Math.floor(Math.random() * 10000);
    return `ORD_${timestamp}_${random}`.slice(0, 63);
  };
 
const paymentAmount = parseFloat(amount); // convert to number


  const initiatePayment = async () => {
     const userId = localStorage.getItem("UserId");
const userName = localStorage.getItem("username") || "Unknown";
    try {
        const token = await getAuthToken();
        if (!token) return;

        const generatedOrderId = generateOrderId();
        setMerchantOrderId(generatedOrderId);

        // Retrieve required values from your React state (not localStorage)
        const userId = localStorage.getItem("UserId");         // replace with your state or props
        const userName = localStorage.getItem("username");     // replace with your state or props
        const amount = paymentAmount;                      // use fixed or from formData/state

        // 1️⃣ Store pending payment in DB before payment
        const payload = {
            userId,
            userName,
            orderId: generatedOrderId,
            amount,
            paymentStatus: "PENDING", // explicitly mark as pending
        };

        await axios.post(`https://ramjitrust.org:4000/form/store`, payload);

        // 2️⃣ Initiate payment
        const response = await axios.post(
            `https://ramjitrust.org:4000/payment/initiate-payment`,
            {
                amount: parseFloat(amount),
                merchantOrderId: generatedOrderId,
                token,
            }
        );

        // 3️⃣ Redirect user to payment URL
        setPaymentUrl(response.data.redirectUrl);
        window.location.href = response.data.redirectUrl;
    } catch (error) {
        console.error("Payment initiation failed:", error);
        setMessage("Failed to initiate payment. Please try again.");
    }
};




  const handleAmountClick = (amt) => {
    setAmount(amt);
    setSelectedAmount(amt);
  };

  const handleCustomAmount = () => {
    setSelectedAmount('custom');
    setAmount('');
  };

  const handleSubmitdonate = async (e) => {
    e.preventDefault();
    if (!amount || isNaN(amount)) {
      alert('Please enter a valid amount');
      return;
    }
    await initiatePayment();
  };

   

  return (
    <div className="container mt-4">
      <h2>
        <FontAwesomeIcon icon={faWallet} className="text-primary me-2" />
        Wallet
      </h2>

      {paymentState && (
        <div className={`alert mt-3 ${
          paymentState === "COMPLETED" ? "alert-success" :
          paymentState === "FAILED" ? "alert-danger" : "alert-warning"
        }`}>
          Payment Status: {paymentState}
        </div>
      )}

      <div className="card mt-3 p-3">
        <h5>Available Balance:</h5>
        <h2>₹{balance}</h2>
      </div>

      <button
        className="btn btn-primary mt-3"
        onClick={() => setFundpage(true)}
      >
        Add Funds
      </button>

      {fundpage && (
        <div className="modal d-block" tabIndex="-1" style={{ background: "rgba(0,0,0,0.5)" }}>
          <div className="modal-dialog">
            <div className="modal-content">
              <form onSubmit={handleSubmitdonate}>
                <div className="modal-header">
                  <h5 className="modal-title">Add Funds</h5>
                  <button type="button" className="btn-close" onClick={() => setFundpage(false)}></button>
                </div>
                <div className="modal-body">
                  <input
                    type="number"
                    className="form-control"
                    placeholder="Enter amount"
                    value={amount}
                    onChange={(e) => setAmount(e.target.value)}
                  />
                  <div className="mt-3">
                    {[100, 500, 1000, 2000, 5000].map((amt) => (
                      <button
                        type="button"
                        key={amt}
                        className={`btn btn-outline-primary me-2 mt-2 ${
                          selectedAmount === amt ? 'active' : ''
                        }`}
                        onClick={() => handleAmountClick(amt)}
                      >
                        ₹{amt}
                      </button>
                    ))}
                    <button
                      type="button"
                      className="btn btn-outline-secondary mt-2"
                      onClick={handleCustomAmount}
                    >
                      Custom
                    </button>
                  </div>
                </div>
                <div className="modal-footer">
                  <button type="submit" className="btn btn-success">Pay</button>
                  <button type="button" className="btn btn-secondary" onClick={() => setFundpage(false)}>Close</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}

      {/* <h4 className="mt-4">Recent Transactions</h4>
      <ul className="list-group mt-2">
        {transactions.map((txn) => (
          <li key={txn.id} className="list-group-item d-flex justify-content-between">
            <div>
              <strong>{txn.description}</strong>
              <div className="text-muted small">{txn.date}</div>
            </div>
            <div className={txn.type === 'credit' ? 'text-success' : 'text-danger'}>
              <FontAwesomeIcon
                icon={txn.type === 'credit' ? faArrowDown : faArrowUp}
                className="me-1"
              />
              ₹{txn.amount.toFixed(2)}
            </div>
          </li>
        ))}
      </ul> */}
    </div>
  );
};

export default WalletPage;
